export const aboutData = {
  siteIntro: {
    title: "关于本站",
    content: "水野朝阳官方粉丝站成立于2024年，是由资深粉丝团队创建与维护的非营利性信息聚合平台。我们致力于为全球水野朝阳的粉丝提供最权威、最全面、最及时的信息服务，涵盖水野朝阳的个人资料、作品信息、活动动态以及粉丝社群交流等多项功能。",
    mission: "我们的使命是搭建一座连接水野朝阳与全球粉丝的桥梁，让每一位喜爱水野朝阳的朋友都能在这里找到归属感，获取最新最准确的信息。我们相信，真诚的粉丝文化能够让这个社群变得更加温暖和有力。",
  },
  reputation: {
    title: "声誉与认可",
    items: [
      {
        icon: "ri-shield-check-line",
        title: "信息权威性",
        desc: "本站所有信息均来源于官方渠道公开发布的内容，确保信息的准确性与时效性，为粉丝提供值得信赖的参考。",
      },
      {
        icon: "ri-user-heart-line",
        title: "粉丝认可度",
        desc: "自上线以来，本站已累计服务超过50万粉丝用户，日均访问量持续增长，获得了广大粉丝群体的一致好评。",
      },
      {
        icon: "ri-star-smile-line",
        title: "内容质量",
        desc: "坚持原创内容与深度报道并重，每一篇文章都经过编辑团队的严格审核，确保为读者提供高质量的阅读体验。",
      },
      {
        icon: "ri-global-line",
        title: "全球影响力",
        desc: "本站支持多语言浏览，读者遍布日本、中国、韩国、东南亚及欧美等地区，是水野朝阳最具国际影响力的粉丝平台。",
      },
    ],
  },
  timeline: {
    title: "发展历程",
    events: [
      { year: "2024年3月", title: "网站正式上线", desc: "水野朝阳官方粉丝站完成筹备，面向全球粉丝正式开放访问。" },
      { year: "2024年6月", title: "内容体系完善", desc: "完成作品数据库建设，收录水野朝阳出道以来的主要作品信息。" },
      { year: "2024年9月", title: "社群功能上线", desc: "新增社群互动功能，粉丝可以在站内进行评论交流与话题讨论。" },
      { year: "2024年12月", title: "里程碑达成", desc: "月活跃用户突破10万，成为水野朝阳最具影响力的中文粉丝平台。" },
      { year: "2025年2月", title: "国际化扩展", desc: "新增多语言支持功能，来自全球各地的粉丝都能使用本站获取信息。" },
    ],
  },
  contact: {
    title: "联系我们",
    description: "如果您有任何问题、建议或商务合作意向，欢迎通过以下方式与我们取得联系。我们将在收到信息后的48小时内回复您。",
    email: "contact@huiswo.cn",
    socialLinks: [
      { platform: "Twitter", url: "https://twitter.com/mizuno_asahi", icon: "ri-twitter-x-line" },
      { platform: "Instagram", url: "https://instagram.com/mizuno_asahi", icon: "ri-instagram-line" },
    ],
  },
};